import { pushParentDL } from "./ga-gmt-iframe";
window.dataLayer = window.dataLayer || [];

function fireOnce(func) {
  let fired = false;

  // tradeInValues example:
  // { year: '2019', make: 'Ford', model: 'Focus', trim: 'LT', leadId: '12345-6789-12345' }
  // Recieve tradeInState, build tradeInValues
  return (tradeInValues, ...args) => {
    if (fired) return;
    fired = true;
    return func(tradeInValues, ...args);
  };
}

function pushDL(event) {
  window.dataLayer.push(event);
  pushParentDL(event);
}

/**
 * Event fired when the trade report is shown to user.
 */
export const fireImpressionEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInImpression", ...tradeInValues })
);

/**
 * Event fired when the user first interacts with the trade in report.
 */
export const fireStartEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInStart", ...tradeInValues })
);

/**
 * Event fired when the user picks their vehicle to trade in.
 */
export const fireVehicleIndicatedEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInVehicleIndicated", ...tradeInValues })
);

/**
 * Event fired when user start interacting with filling out vehicle and contact information.
 */
export const fireFormInitiationEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInFormInitiation", ...tradeInValues })
);

/**
 * Event fired when user submits a filled out trade form
 */
export const fireFormSubmitEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInFormSubmission", ...tradeInValues })
);

/**
 * Event fired when user sees the trade in report.
 */
export const fireCompleteEvent = fireOnce((tradeInValues) =>
  pushDL({ event: "tradeInComplete", ...tradeInValues })
);
